import { Functionality } from 'api/userPermissions/userPermissions.enum';

export enum PermissionOptions {
  FULL = 'full',
  EDIT_ONLY = 'edit-only',
}

export type PermissionRowProps = {
  functionality: Functionality;
  title: string;
  options?: PermissionOptions;
  disabled?: boolean;
  modifyDisabled?: boolean;
};
